const buttonStyle = {
  button: {
    minHeight: "auto",
    minWidth: "auto",
    backgroundColor: "#2f72f2",
    color: "#ffffff",
    boxShadow: "0 8px 18px rgba(47,114,242,0.22)",
    border: "none",
    borderRadius: "8px",
    position: "relative",
    padding: "8px 16px",
    margin: ".3125rem 1px",
    fontSize: "13px",
    fontWeight: "600",
    fontFamily: '"Inter", "Roboto", sans-serif',
    textTransform: "none",
    letterSpacing: "0",
    willChange: "box-shadow, transform",
    transition:
      "box-shadow .2s cubic-bezier(.4,0,1,1), background-color .2s cubic-bezier(.64,.09,.08,.97), color .2s",
    lineHeight: "1.42857143",
    textAlign: "center",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    touchAction: "manipulation",
    cursor: "pointer",
    "&:hover,&:focus": {
      color: "#ffffff",
      backgroundColor: "#1d5fce",
      boxShadow: "0 10px 24px rgba(47,114,242,0.28)",
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      position: "relative",
      display: "inline-block",
      top: "0",
      marginTop: "-1em",
      marginBottom: "-1em",
      fontSize: "1.1rem",
      marginRight: "4px",
      verticalAlign: "middle",
    },
    "& svg": {
      position: "relative",
      display: "inline-block",
      top: "0",
      width: "18px",
      height: "18px",
      marginRight: "4px",
      verticalAlign: "middle",
    },
    "&$justIcon": {
      "& .fab,& .fas,& .far,& .fal,& .material-icons": {
        marginTop: "0px",
        position: "absolute",
        width: "100%",
        transform: "none",
        left: "0px",
        top: "0px",
        height: "100%",
        lineHeight: "41px",
        fontSize: "20px",
      },
    },
  },
  fullWidth: { width: "100%" },
  primary: {
    backgroundColor: "#2f72f2",
    boxShadow: "0 8px 18px rgba(47,114,242,0.22)",
    "&:hover,&:focus": {
      backgroundColor: "#1d5fce",
      boxShadow: "0 10px 24px rgba(47,114,242,0.28)",
    },
  },
  info: {
    backgroundColor: "#2f72f2",
    boxShadow: "0 8px 18px rgba(47,114,242,0.22)",
    "&:hover,&:focus": {
      backgroundColor: "#1d5fce",
      boxShadow: "0 10px 24px rgba(47,114,242,0.28)",
    },
  },
  success: {
    backgroundColor: "#22c55e",
    boxShadow: "0 4px 15px rgba(34,197,94,0.3)",
    "&:hover,&:focus": {
      backgroundColor: "#16a34a",
      boxShadow: "0 6px 20px rgba(34,197,94,0.4)",
    },
  },
  warning: {
    backgroundColor: "#f59e0b",
    boxShadow: "0 4px 15px rgba(245,158,11,0.3)",
    "&:hover,&:focus": {
      backgroundColor: "#d97706",
      boxShadow: "0 6px 20px rgba(245,158,11,0.4)",
    },
  },
  danger: {
    backgroundColor: "#ef4444",
    boxShadow: "0 4px 15px rgba(239,68,68,0.3)",
    "&:hover,&:focus": {
      backgroundColor: "#dc2626",
      boxShadow: "0 6px 20px rgba(239,68,68,0.4)",
    },
  },
  rose: {
    backgroundColor: "#ec4899",
    boxShadow: "0 4px 15px rgba(236,72,153,0.3)",
    "&:hover,&:focus": { backgroundColor: "#db2777" },
  },
  white: {
    "&,&:focus,&:hover": { backgroundColor: "#ffffff", color: "#2d3748" },
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },
  twitter: {
    backgroundColor: "#55acee",
    color: "#ffffff",
    "&:hover,&:focus": { backgroundColor: "#3ea1ec" },
  },
  facebook: {
    backgroundColor: "#3b5998",
    color: "#ffffff",
    "&:hover,&:focus": { backgroundColor: "#3b5998" },
  },
  google: {
    backgroundColor: "#dd4b39",
    color: "#ffffff",
    "&:hover,&:focus": { backgroundColor: "#d73925" },
  },
  linkedin: {
    backgroundColor: "#0077b5",
    color: "#ffffff",
    "&:hover,&:focus": { backgroundColor: "#0077b5" },
  },
  pinterest: {
    backgroundColor: "#cc2127",
    color: "#ffffff",
    "&:hover,&:focus": { backgroundColor: "#b21d22" },
  },
  youtube: {
    backgroundColor: "#e52d27",
    color: "#ffffff",
    "&:hover,&:focus": { backgroundColor: "#d41f1a" },
  },
  github: {
    backgroundColor: "#333333",
    color: "#ffffff",
    "&:hover,&:focus": { backgroundColor: "#333333" },
  },
  behance: {
    backgroundColor: "#1769ff",
    color: "#ffffff",
    "&:hover,&:focus": { backgroundColor: "#1769ff" },
  },
  dribbble: {
    backgroundColor: "#ea4c89",
    color: "#ffffff",
    "&:hover,&:focus": { backgroundColor: "#ea4c89" },
  },
  reddit: {
    backgroundColor: "#ff4500",
    color: "#ffffff",
    "&:hover,&:focus": { backgroundColor: "#ff4500" },
  },
  transparent: {
    "&,&:focus,&:hover": {
      color: "inherit",
      background: "transparent",
      boxShadow: "none",
    },
  },
  disabled: { opacity: "0.5", pointerEvents: "none" },
  lg: { padding: "10px 22px", fontSize: "14px", borderRadius: "8px" },
  sm: { padding: "6px 12px", fontSize: "12px", borderRadius: "7px" },
  round: { borderRadius: "8px" },
  block: { width: "100% !important" },
  link: {
    "&,&:hover,&:focus": {
      backgroundColor: "transparent",
      color: "#2f72f2",
      boxShadow: "none",
    },
  },
  justIcon: {
    paddingLeft: "12px",
    paddingRight: "12px",
    fontSize: "20px",
    height: "41px",
    minWidth: "41px",
    width: "41px",
    "& .fab,& .fas,& .far,& .fal,& .material-icons": { marginRight: "0px" },
    "& svg": { marginRight: "0px" },
  },
};

export default buttonStyle;
